export const DEFAULT_LANDING_PAGE_TITLE = 'Welcome to Nurole - the best board-level recruitment'